import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import RegistrationModal from '../../../components/feature/RegistrationModal';

interface TournamentHeroProps {
  onViewSchedule: () => void;
}

export default function TournamentHero({ onViewSchedule }: TournamentHeroProps) {
  const { t } = useTranslation();
  const [isRegistrationOpen, setIsRegistrationOpen] = useState(false);

  return (
    <>
      <section className="relative min-h-[75vh] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-gray-900 via-purple-900/30 to-gray-900">
          <div className="absolute inset-0 opacity-20">
            <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMSIvPjwvcGF0dGVybj48L2RlZnM+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0idXJsKCNncmlkKSIvPjwvc3ZnPg==')] opacity-10"></div>
          </div>
        </div>
        
        <div className="absolute inset-0">
          <img 
            src="https://public.readdy.ai/ai/img_res/10125ed8c94728f356c4d47c0046242b.jpg"
            alt="Tournament"
            className="w-full h-full object-cover object-center opacity-40"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-purple-900/40 to-black/60"></div>
        </div>

        <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 text-center">
          <div className="inline-flex items-center bg-purple-600/20 border border-purple-500/50 rounded-full px-4 sm:px-5 py-2 mb-6 backdrop-blur-sm">
            <i className="ri-trophy-line text-purple-400 mr-2"></i>
            <span className="text-purple-300 font-semibold text-xs sm:text-sm">COMPETITIVE TOURNAMENTS</span>
          </div>
          
          <h1 className="text-4xl sm:text-5xl md:text-7xl font-bold text-white mb-4 sm:mb-6 leading-tight">
            Epic Gaming <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-400">Tournaments</span>
          </h1>
          <p className="text-lg sm:text-xl md:text-2xl text-gray-300 mb-8 sm:mb-10 max-w-3xl mx-auto leading-relaxed">
            Join competitive tournaments, climb the leaderboards, and compete for massive prize pools.
            From casual matches to professional esports competitions.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center">
            <button
              onClick={() => setIsRegistrationOpen(true)}
              className="bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-base sm:text-lg font-semibold transition-all transform hover:scale-105 shadow-lg shadow-purple-500/50 cursor-pointer whitespace-nowrap w-full sm:w-auto"
            >
              <i className="ri-trophy-line mr-2"></i>
              Join Tournament
            </button>
            <button
              onClick={onViewSchedule}
              className="bg-gray-800/80 backdrop-blur-sm border-2 border-purple-500/50 text-purple-300 hover:bg-purple-600 hover:text-white hover:border-purple-600 px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-base sm:text-lg font-semibold transition-all transform hover:scale-105 cursor-pointer whitespace-nowrap w-full sm:w-auto"
            >
              <i className="ri-calendar-line mr-2"></i>
              View Schedule
            </button>
          </div>
        </div>
      </section>

      <RegistrationModal
        isOpen={isRegistrationOpen}
        onClose={() => setIsRegistrationOpen(false)}
      />
    </>
  );
}
